import { createAsyncThunk } from "@reduxjs/toolkit";
import doAsync from "../../infrastructure/doAsync";
import { REGIONS } from "../../widgets/busyIndicator";

// const mockUnitForCommodity = [{ unit: "KWh" }, { unit: "wh" }];

export const searchForAccount = createAsyncThunk(
  "getAccount/getAll",
  async (accountToBeSearched, thunkArgs, { useCaching, noBusySpinner } = {}) =>
    await doAsync({
      url: `generator/Leads/getaddress`,
      useCaching,
      noBusySpinner,
      busyIndicatorName: REGIONS.SEARCH_ACCOUNT,
      httpMethod: "post",
      httpConfig: {
        body: JSON.stringify(accountToBeSearched),
      },
      errorMessage: "Unable to load Account. Please try again later.",
      ...thunkArgs,
    })
);

export const saveAllInformation = createAsyncThunk(
  "saveInformation",
  async ({ useCaching, noBusySpinner, customerData } = {}, thunkArgs) =>
    await doAsync({
      url: `generator/PALeadCapturePortal/submit`,
      useCaching,
      noBusySpinner,
      busyIndicatorName: REGIONS.SAVE_ALL_INFORMATION,
      httpMethod: "post",
      httpConfig: {
        body: JSON.stringify(customerData),
      },
      errorMessage: "Error while Saving data. Please Try again later",
      ...thunkArgs,
    })
);

export const getUnitsForCommodity = createAsyncThunk(
  "getUnitsForCommodity",
  async ({ useCaching, noBusySpinner } = {}, thunkArgs) =>
    await doAsync({
      url: `generator/Uom`,
      useCaching,
      noBusySpinner,
      errorMessage: "Failed to load units. Please try again later",
      ...thunkArgs,
    })
);

export const getEnrollmentFields = createAsyncThunk(
  "generator/getEnrollmentFields",
  async (supplier, thunkArgs, { useCaching, noBusySpinner } = {}) =>
    await doAsync({
      url: `generator/getEnrollmentFields`,
      useCaching,
      noBusySpinner,
      httpMethod: "post",
      httpConfig: {
        body: JSON.stringify(supplier),
      },
      errorMessage: "Failed to load Field. Please try again later",
      ...thunkArgs,
    })
);

export const getUSStates = createAsyncThunk(
  "getUSStates",
  async ({ useCaching, noBusySpinner } = {}, thunkArgs) =>
    await doAsync({
      url: `generator/States`,
      useCaching,
      noBusySpinner,
      errorMessage: "Failed to load Field. Please try again later",
      ...thunkArgs,
    })
);

// export const getSupplierFields = createAsyncThunk(
//   "getSupplierFields",
//   async ({SupplierId,StateId, CommodityTypeId, rateClass, utilityId, companyId}, thunkArgs, { useCaching, noBusySpinner } = {}) =>
//     await doAsync({
//       url: `generator/Contracts/GetContractTemplateforPowerPortal?supplierId=${SupplierId}&stateId=${StateId}&commodity=${CommodityTypeId}&companyId=${companyId}&rateClass=${rateClass}&utilityId=${utilityId}`,
//       useCaching,
//       noBusySpinner,
//       httpMethod: "get",
//       errorMessage: "Failed to Supplier Fields. Please try again later",
//       ...thunkArgs,
//     })
// );

export const getSupplierFields = createAsyncThunk(
  "getSupplierFields",
  async ({SupplierId,StateId, CommodityTypeId, rateClass, utilityId, companyId, clientId}, thunkArgs, { useCaching, noBusySpinner } = {}) =>
    await doAsync({
      url: `generator/ContractTemplate/getContractTemplate?supplierId=${SupplierId}&stateId=${StateId}&commodity=${CommodityTypeId}&companyId=${companyId}&rateClass=${rateClass}&utilityId=${utilityId}&clientId=${clientId}`,
      useCaching,
      noBusySpinner,
      httpMethod: "get",
      errorMessage: "Failed to Supplier Fields. Please try again later",
      ...thunkArgs,
    })
);



export const searchForAccountByAddress = createAsyncThunk(
  "getAccount/getAll",
  async (accountToBeSearched, thunkArgs, { useCaching, noBusySpinner } = {}) =>
    await doAsync({
      url: `generator/Leads/getaddress`,
      useCaching,
      noBusySpinner,
      busyIndicatorName: REGIONS.SEARCH_ACCOUNT,
      httpMethod: "post",
      httpConfig: {
        body: JSON.stringify(accountToBeSearched),
      },
      errorMessage: "Unable to load Account. Please try again later.",
      ...thunkArgs,
    })
);

export const getAcountPattern = createAsyncThunk(
  "getAcountPattern",
  async (payload, thunkArgs, { useCaching, noBusySpinner } = {}) =>
    await doAsync({
      url: `generator/Utilities/GetAcountPattern`,
      useCaching,
      noBusySpinner,
      httpMethod: "post",
      httpConfig: {
        body: JSON.stringify(payload),
      },
      errorMessage: "Unable to load Account. Please try again later.",
      ...thunkArgs,
    })
);

export const spCreateLead = createAsyncThunk(
  "createLead",
  async(payload, thunkArgs, {useCaching, noBusySpinner} = {}) => 
  await doAsync({
    url: `Leads/CreateLead`,
      useCaching,
      noBusySpinner,
      httpMethod: "post",
      httpConfig: {
        body: JSON.stringify(payload),
      },
      errorMessage: "Unable to load Account. Please try again later.",
      ...thunkArgs,
  })
);